const ADMIN_DASHBOARD_MENU_ITEMS = [
  { id: 'resumen', label: 'Dashboard', icon: 'fas fa-chart-line' },
  { id: 'mensajes', label: 'Mensajes', icon: 'fas fa-envelope', path: '/mensajes' },
  { id: 'profesores', label: 'Profesores', icon: 'fas fa-chalkboard-teacher' },
  { id: 'alumnos', label: 'Alumnos', icon: 'fas fa-user-graduate' },
  { id: 'aulas', label: 'Aulas estudiantes', icon: 'fas fa-door-open' },
  { id: 'aulas-docentes', label: 'Aulas docentes', icon: 'fas fa-chalkboard-teacher' },
  { id: 'areas', label: 'Áreas', icon: 'fas fa-sitemap' },
  { id: 'divisiones', label: 'Divisiones', icon: 'fas fa-code-branch' },
  { id: 'materias', label: 'Materias', icon: 'fas fa-book' },
  { id: 'cursos', label: 'Cursos', icon: 'fas fa-layer-group' },
  { id: 'procesos-asincronicos', label: 'Solicitudes de procesos', icon: 'fas fa-tasks' },
  { id: 'asistentes', label: 'Asistentes OpenAI', icon: 'fas fa-robot' },
  { id: 'agentes-clasicos-gpt', label: 'Asistentes IA', icon: 'fas fa-robot' },
];

const ADMIN_FORM_MENU_ITEMS = [
  { id: 'colegio', label: 'Colegio', icon: 'fas fa-map-marker-alt' },
  ...ADMIN_DASHBOARD_MENU_ITEMS.filter((item) => item.id !== 'resumen'),
];

const ADMIN_ENTITIES_GROUP_ID = 'admin-entidades';
const ADMIN_ENTITIES_ITEM_IDS = ['profesores', 'alumnos', 'areas', 'divisiones', 'materias', 'cursos'];

const normalizeRoleName = (user) => (user?.roleName || user?.nombreRol || user?.role || '').toLowerCase().trim();

const isAdminColegio = (user) => {
  const roleName = normalizeRoleName(user);
  return roleName === 'adminarea'
    || roleName === 'admin area'
    || roleName.includes('adminarea')
    || roleName.includes('admin area')
    || roleName.includes('admin colegio')
    || roleName.includes('admin del colegio');
};

const isFeatureEnabled = (featureFlags, name) => {
  if (!Array.isArray(featureFlags)) return false;
  return featureFlags.some((flag) => {
    const flagName = flag?.nombre || flag?.Nombre || '';
    const activo = flag?.activo ?? flag?.Activo ?? false;
    return flagName.toLowerCase() === name.toLowerCase() && !!activo;
  });
};

const hasOpenAIChatsEnabled = (featureFlags) => isFeatureEnabled(featureFlags, 'PermiteChatsOpenAI');

const filterAdminMenuItems = (items, user, featureFlags = []) => {
  if (!Array.isArray(items)) return [];
  const hasModuloAlumnos = isFeatureEnabled(featureFlags, 'ModuloAlumnos');
  const hasAgentesClasicos = isFeatureEnabled(featureFlags, 'PermiteAgentesClasicosGPT');
  const hasOpenAIChats = hasOpenAIChatsEnabled(featureFlags);
  let filteredItems = items.slice();

  if (!hasModuloAlumnos) {
    filteredItems = filteredItems.filter((item) =>
      item.id !== 'alumnos'
      && item.id !== 'aulas'
    );
  }

  if (!hasOpenAIChats) {
    filteredItems = filteredItems.filter((item) => item.id !== 'asistentes');
  }

  if (!hasAgentesClasicos) {
    filteredItems = filteredItems.filter((item) => item.id !== 'agentes-clasicos-gpt');
  }

  return filteredItems;
};

const groupAdminEntityMenuItems = (items) => {
  if (!Array.isArray(items)) return [];

  const entityIdSet = new Set(ADMIN_ENTITIES_ITEM_IDS);
  const entityChildren = items.filter((item) => entityIdSet.has(item.id));

  if (entityChildren.length === 0) return items;

  const groupedItems = [];
  let groupInserted = false;

  items.forEach((item) => {
    if (entityIdSet.has(item.id)) {
      if (!groupInserted) {
        groupedItems.push({
          id: ADMIN_ENTITIES_GROUP_ID,
          label: 'Admin. Entidades',
          icon: 'fas fa-database',
          children: entityChildren,
          defaultOpen: false,
          openOnActiveChild: false
        });
        groupInserted = true;
      }
      return;
    }

    groupedItems.push(item);
  });

  return groupedItems;
};

const navigateAdminMenuItem = (navigate, item, options = {}) => {
  if (typeof navigate !== 'function' || !item?.id) return;

  const dashboardPath = options.dashboardPath || '/admin-dashboard';
  const tabState = options.tabState || {};

  if (item.path) {
    navigate(item.path);
    return;
  }

  if (item.id === 'colegio') {
    navigate('/admin/select-colegio');
    return;
  }

  if (item.id === 'resumen') {
    navigate(dashboardPath);
    return;
  }

  if (item.id === 'aulas-docentes') {
    navigate('/aulas-docentes');
    return;
  }

  if (item.id === 'agentes-clasicos-gpt') {
    navigate('/mis-agentes-clasicos-gpt');
    return;
  }

  navigate(dashboardPath, { state: { ...tabState, tab: item.id } });
};

export {
  ADMIN_ENTITIES_GROUP_ID,
  ADMIN_DASHBOARD_MENU_ITEMS,
  ADMIN_ENTITIES_ITEM_IDS,
  ADMIN_FORM_MENU_ITEMS,
  filterAdminMenuItems,
  groupAdminEntityMenuItems,
  hasOpenAIChatsEnabled,
  isAdminColegio,
  isFeatureEnabled,
  navigateAdminMenuItem,
  normalizeRoleName
};
